import * as yup from 'yup';
import {
  date,
  defaultString,
  defaultRequiredString,
  requiredCountry,
} from '../_types';
import { useFormikContext } from "formik";

/**
 * @param {[]} values
 * @returns {Object}
 */
export default ({countries}) => {
  // const countries = JSON.parse(localStorage.getItem('countries'));

  return yup.object().shape({
    information: yup.object().shape({
      title: yup
        .string()
        .oneOf(['', 'dr', 'prof', 'profdr']),
      firstName: defaultRequiredString(),
      lastName: defaultRequiredString(),
      birthday: date()
        .required()
        .max(new Date()),
      birthCity: defaultRequiredString(),
      birthCountry: requiredCountry(countries),
      gender: yup
        .string()
        .required()
        .oneOf(['f', 'm', 'd']),
      // photo: yup
      //   .string()
      //   .test((value) => {return value != "null"})
      //   .oneOf([yup.ref('passphoto'), null], 'Passfoto ist falsch'),
      // phone: yup.string().matches(/^\+{0,1}[\(\)\-\/\ 0-9]{1,20}$/).required(),// defaultRequiredString().matches(/^\+{0,1}[\(\)\-\/\ 0-9]{1,20}$/),
      // phone2: yup.string().matches(/^\+{0,1}[\(\)\-\/\ 0-9]{1,20}$/),
      // employer: yup.string().max(254),
    }),
    address: yup.object().shape({
      street: defaultRequiredString(),
      houseNumber: defaultRequiredString(),
      postalCode: yup
        .string()
        .required()
        .max(10),
      city: defaultRequiredString(),
      country: requiredCountry(countries),
      phone: yup.string().matches(/^\+{0,1}[\(\)\-\/\ 0-9]{1,20}$/).required(),
      email: defaultRequiredString().email(),
      emailConfirm: yup
        .string()
        .required()
        .email()
        .oneOf([yup.ref('email'), null], 'E-Mail ist falsch'),
    })
  });
}
